import React from "react";
import { motion } from "framer-motion";
import jerseyImage from "../assets/images/jersey.png";
import racepackImage from "../assets/images/racepack.png";

export const RaceInfo = ({ categoryName }) => {
  const trimmedCategoryName = categoryName ? categoryName.trim() : "";

  const qualifications = {
    "MOUNTAIN UPHILL (5K)": ["Qualification information will be updated soon"],
    "MOUNTAIN CLASSIC (10K)": ["Qualification information will be updated soon"],
    "SHORT TRAIL (42K)": ["Qualification information will be updated soon"],
    "LONG TRAIL (75 K)": ["Qualification information will be updated soon"],
  };

  const raceInclusions = {
    "MOUNTAIN UPHILL (5K)": ["Race inclusion information will be updated soon"],
    "MOUNTAIN CLASSIC (10K)": ["Race inclusion information will be updated soon"],
    "SHORT TRAIL (42K)": ["Race inclusion information will be updated soon"],
    "LONG TRAIL (75 K)": ["Race inclusion information will be updated soon"],
  };

  const qualificationList = qualifications[trimmedCategoryName];
  const inclusionList = raceInclusions[trimmedCategoryName];

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6 mb-8">
      {/* Existing Qualification and Race Inclusions Container */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {/* Kolom Kualifikasi (Kiri) */}
        <motion.div
          className="space-y-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h3 className="text-xl font-bold text-lime-600 mb-4">
            Qualification
          </h3>
          <ul className="list-disc list-inside text-gray-700">
            {qualificationList && qualificationList.length > 0 ? (
              qualificationList.map((item, index) => (
                <li key={index} className="text-sm mb-2">
                  {item}
                </li>
              ))
            ) : (
              <li className="text-sm mb-2">
                No specific qualification for this category. Please check category data.
              </li>
            )}
          </ul>
        </motion.div>

        {/* Kolom Inklusi Perlombaan (Kanan) */}
        <motion.div
          className="space-y-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h3 className="text-xl font-bold text-lime-600 mb-4">
            Race Inclusions
          </h3>
          <ul className="list-disc list-inside text-gray-700">
            {inclusionList && inclusionList.length > 0 ? (
              inclusionList.map((item, index) => (
                <li key={index} className="text-sm mb-2">
                  {item}
                </li>
              ))
            ) : (
              <li className="text-sm mb-2">
                No inclusion information available for this category. Please check category data.
              </li>
            )}
          </ul>
        </motion.div>
      </div>

      {/* New Container for Images (No Border) */}
      {/* <div className="bg-white rounded-xl p-4">
        <div className="flex flex-col md:flex-row justify-center md:gap-10 items-center">
          <motion.div
            className="flex justify-center md:justify-end"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <img
              src={jerseyImage}
              alt="Event Jersey"
              className="h-auto max-h-[300px] object-contain rounded-lg"
            />
          </motion.div>

          <motion.div
            className="flex justify-center md:justify-start"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <img
              src={racepackImage}
              alt="Race Pack"
              className="h-auto max-h-[300px] object-contain rounded-lg"
            />
          </motion.div>
        </div>
      </div> */}
    </div>
  );
};
